// src/App.jsx

import React, { useEffect, useState } from "react";
import WalletConnectProvider from "./WalletConnectContext";
import ErrorBoundary from "./components/ErrorBoundary";
import AppBootScreen from "./components/AppBootScreen";
import MarketStandaloneLayout from "./components/MarketStandaloneLayout";
import WebAppLayout from "./WebAppLayout";
import { OmniProvider } from "./OmniContext";
import { isStandaloneMarketEntry } from "./projectMeta";

export default function App() {
  const [bootVisible, setBootVisible] = useState(true);
  const standaloneMarket = isStandaloneMarketEntry(
    typeof window !== "undefined" ? window.location : null,
    typeof document !== "undefined" ? document.documentElement : null,
  );

  useEffect(() => {
    const raf =
      typeof window !== "undefined" && typeof window.requestAnimationFrame === "function"
        ? window.requestAnimationFrame.bind(window)
        : (callback) => setTimeout(callback, 0);
    const caf =
      typeof window !== "undefined" && typeof window.cancelAnimationFrame === "function"
        ? window.cancelAnimationFrame.bind(window)
        : clearTimeout;

    const frameId = raf(() => {
      setBootVisible(false);
    });

    return () => caf(frameId);
  }, []);

  if (bootVisible) {
    const pathname = typeof window !== "undefined" ? window.location?.pathname || "/" : "/";
    return <AppBootScreen pathname={pathname} showBottomNavPlaceholder={!standaloneMarket} />;
  }

  return (
    <WalletConnectProvider>
      <OmniProvider>
        <ErrorBoundary>
          {standaloneMarket ? <MarketStandaloneLayout /> : <WebAppLayout />}
        </ErrorBoundary>
      </OmniProvider>
    </WalletConnectProvider>
  );
}
